<div class="patient-order-details-page">
  <div *ngIf="!loaded">
    <h3 style="text-align: center">LOADING ORDER</h3>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>

  <div *ngIf="loaded" class="patient-order-details">
    <div class="order-details-toolbar">
      <button mat-button type="button" (click)="navigateBack()">
        <mat-icon>arrow_back</mat-icon>
        <span>BACK TO PATIENT</span>
      </button>
    </div>

    <div
      fxLayout="row"
      fxLayoutAlign="space-between end"
      fxLayoutGap="10px"
      class="patient-order-header"
      [formGroup]="orderFormGroup"
    >
      <div fxFlex="0 0 75px">PATIENT:</div>
      <div fxFlex="1 1 calc(35%-75px)">
        {{ patient?.lastName }}, {{ patient?.firstName }}
      </div>
      <div fxFlex="0 0 50px" style="text-align: center">CELL:</div>
      <div fxFlex="1 1 calc(25%-50px)">{{ patient?.cell }}</div>
      <div fxFlex="1 1 40%" style="text-align: center">
        <span class="invoice-number" *ngIf="orderFormGroup?.value?.invoiceNumber">
          No. {{ orderFormGroup.value.type }}&nbsp;&ndash;&nbsp;{{ orderFormGroup.value.invoiceNumber }}
        </span>
        <mat-form-field appearance="outline" style="width: 100%; margin-bottom: 0" floatLabel="always">
          <mat-label>INTERNAL NOTE</mat-label>
          <textarea matInput rows="1" formControlName="notes"></textarea>
        </mat-form-field>
      </div>
    </div>

    <mat-accordion class="order-details-accordion" multi>
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>FRAME</mat-panel-title>
        </mat-expansion-panel-header>
        <app-frame-details
          [orderForm]="orderFormGroup"
          [patient]="patient"
          [authorized]="authorized"
          (saveOrder)="onSave($event.destination)"
        ></app-frame-details>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>PRESCRIPTION</mat-panel-title>
        </mat-expansion-panel-header>
        <app-prescription-details
          [orderForm]="orderFormGroup"
          [patient]="patient"
          (saveOrder)="onSave($event.destination)"
        ></app-prescription-details>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>LENS</mat-panel-title>
        </mat-expansion-panel-header>
        <app-lens-details
          [orderForm]="orderFormGroup"
          (saveOrder)="onSave($event.destination)"
        ></app-lens-details>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>REPAIR / WARRANTY</mat-panel-title>
        </mat-expansion-panel-header>
        <app-repair-details
          [orderForm]="orderFormGroup"
          (saveOrder)="onSave($event.destination)"
        ></app-repair-details>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
